import React from 'react'

const Form = (props) => {
    return (
        <form>
            <div className="inputs">
                <div className="form-input">
                    <label>Email</label>
                    <input type="text" value={props.profile.email} disabled />
                </div>
                <div className="form-input">
                    <label>Firstname</label>
                    <input type="text" name="firstname" value={props.profile.firstname} onChange={props.onChange} />
                    <span className="error">{props.errors.firstname}</span>
                </div>
                <div className="form-input">
                    <label>Middlename</label>
                    <input type="text" name="middlename" value={props.profile.middlename} onChange={props.onChange} />
                    <span className="error">{props.errors.middlename}</span>
                </div>
                <div className="form-input">
                    <label>Lastname</label>
                    <input type="text" name="lastname" value={props.profile.lastname} onChange={props.onChange} />
                    <span className="error">{props.errors.lastname}</span>
                </div>
                <div className="form-input">
                    <label>Phone</label>
                    <input type="text" name="phone" value={props.profile.phone} onChange={props.onChange} />
                    <span className="error">{props.errors.phone}</span>
                </div>
                <div className="form-input">
                    <label>Specialty</label>
                    <input type="text" name="specialty" placeholder='e.g Property Law, Litigation & Dispute Resolution' value={props.profile.specialty} onChange={props.onChange} />
                    <span className="error">{props.errors.specialty}</span>
                </div>
                <div className="row" id="showInPublicDirecory">
                    <div className="form-label">
                        <label>Public Directory Visibility</label>
                    </div>
                    <div className="form-input">
                        <select name="showInPublicDirectory" onChange={props.onChange} value={props.profile.showInPublicDirectory}>
                            <option value=""></option>
                            <option value="true">Show</option>
                            <option value="false">Hide</option>
                        </select>
                        <span className="error">{props.errors.showInPublicDirectory}</span>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="form-label">
                    <label>Photo</label>
                </div>
                {
                    props.photoUrl !== null && <>
                    <img className='photo' src={props.photoUrl} alt={props.firstname}/>
                    </>
                }
                <div className="form-input">
                    <input type="file" name="photo" accept="image/jpeg" onChange={e => props.onChange({
                        target: {
                            name: 'photo',
                            value: e.target.files[0]
                        }
                    })} />
                    <span className="error">{props.errors.thumbnail}</span>
                </div>
            </div>
            <div className="actions">
                <button type="submit" onClick={props.onSubmit}>Save</button>
            </div>
        </form>
    )
}

export default Form